module.exports = __webpack_public_path__ + "static/media/concert-3.small.e19f8b23.png";